import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { ICommonServiceProps } from "@api/types/globalService.types";
import { useQuery } from "@tanstack/react-query";
import { getAllSegmentsAPI, getSingleSegmentsAPI } from "./segments.api";
import useGlobalDebounceHandler from "../useGlobalDebounceHandler";
import { useState } from "react";

const useAllSegmentsService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters,
}: ICommonServiceProps) => {
  const [searchSegmentsQuery, setSearchSegmentsQuery] = useState<string>("");

  const { debouncedQuery } = useGlobalDebounceHandler(searchSegmentsQuery);
  const allSegmentsService = useQuery({
    queryKey: [...CACHE_KEYS.SEGMENTS, page, per_page, ...cacheKeys],
    queryFn: () =>
      getAllSegmentsAPI({
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });

  return {
    states: { searchSegmentsQuery, setSearchSegmentsQuery },
    services: { allSegmentsService },
  };
};

const useSingleSegmentsService = ({
  singleSegmentsId,
  enableQuery = true,
}: {
  singleSegmentsId: string;
  enableQuery?: boolean;
}) => {
  return useQuery({
    queryKey: [...CACHE_KEYS.SEGMENTS, singleSegmentsId],
    queryFn: () => getSingleSegmentsAPI(singleSegmentsId),
    enabled: !!(singleSegmentsId && enableQuery),
  });
};

export { useAllSegmentsService, useSingleSegmentsService };
